import {
  AccountResource,
  isDefined,
  OrderExchangeData,
  OrderManagementResource,
  useOrderExchangeCommon,
  UseOrderExchangeCommonParams,
  UseOrderExchangeCommonPlatformParams,
} from '@eih-netbroker/common';
import { useEffect, useMemo } from 'react';
import { useOptions } from '../../../../shared/services/useOptions';
import { useResource, useResourceHeaders } from '../../../../shared/services/useResource';

// TODO remove "2" suffix when web fully adapts new Order ticket
export const useOrderExchange2 = (params: UseOrderExchangeCommonParams): OrderExchangeData => {
  const accountResource = useResource(AccountResource);
  const orderManagementResource = useResource(OrderManagementResource);
  const { getResourceHeaderWithTokenForAccount } = useResourceHeaders();
  const { getTradingSessionOptions } = useOptions();

  const platformParams = useMemo<UseOrderExchangeCommonPlatformParams>(
    () => ({
      accountResource,
      orderManagementResource,
      getResourceHeaderWithTokenForAccount,
      getTradingSessionOptions,
    }),
    [accountResource, getResourceHeaderWithTokenForAccount, getTradingSessionOptions, orderManagementResource],
  );

  const exchangeData = useOrderExchangeCommon(params, platformParams);

  // "All accounts" (client-level) selection yields an undefined account, so the exchange
  // conditions never resolve. Force the toggle off in that case.
  const { setEnabled } = exchangeData;
  useEffect(() => {
    if (!isDefined(params.selectedAccount)) {
      setEnabled(false);
    }
  }, [params.selectedAccount, setEnabled]);

  return exchangeData;
};
